export default {
  type: "object",
  properties: {
    size_chart_primary: {
      type: "integer",
      description: "id of main marking for this table",
      example: 1
    },
    client_primary: {
      type: "integer|null",
      description: "id of main marking chosen by the client",
      example: "null"
    },
    supported: {
      $ref: "#/components/schemas/marking"
    }
  }
};
